import { Button } from "rsuite";
import { SvgExport } from "../../assets/icons/index";
import { LibExport } from "../generic/exportDownload";
import { AppRoutesApi } from '../../config/appRoutes';


export const ExportTemplateButton = () => {
  return (
    <Button
      size="sm"
      appearance="primary"
      className="table-extra-buttons fw-bold"
      onClick={()=>{
        LibExport.DownloadExport(AppRoutesApi.User.ExportUserTemplate, "User Template")
      }}
    >
      <SvgExport /> Export Template
    </Button>
  );
};
